import { useParams } from 'react-router-dom';
import './Map.css';
import AddressMap from '../AddressMap/AddressMap';

function Map() {
    const { lon, lat } = useParams()
    const location = { center: [Number(lon), Number(lat)], zoom: 11 }
    if (!lon || !lat || !Number(lon) || !Number(lat)) return null
    console.log({ location })
    return (
        <div className="map">
            <AddressMap
                location={location}
            />
        </div>
    );
}

export default Map;
